export type normal = "normal";
export type default_ = "default";
export type pointer = "pointer";

//  export\s*type\s*((?:\w|_)+)\s*=\s*"(.+?)";
//    $1 |

export type CSSCursorType = 
  normal |
  default_ |
  pointer
;

export class CSSCursor
{
  //  export\s*type\s*((?:\w|_)+)\s*=\s*"(.+?)";
  //  static readonly $1:$1 = "$2";

  static readonly normal:normal = "normal";
  static readonly default_:default_ = "default";
  static readonly pointer:pointer = "pointer";
  
}